// extracted by mini-css-extract-plugin
module.exports = {"card":"_1dUuzE8V3fSpKtD71aYH3n","categoryName":"_3XwHj723y0PfyUzOKjGhLX"};